import type MapFeature from '@/lib/map-feature'

function getFirstPresentationValue(feature: MapFeature): string | undefined {
  const firstRow = feature.presentation?.content?.[0]?.[0]
  if (!firstRow) {
    return undefined
  }
  const firstValue = Object.values(firstRow)[0]
  return typeof firstValue === 'string' ? firstValue : undefined
}

/**
 * First presentable string for a MapFeature: explicit `label`, properties
 * label, or the first value of its presentation content. Empty when none.
 */
export function getFeatureLabel(feature: MapFeature): string {
  const candidates = [
    feature.label,
    feature.properties?.label,
    getFirstPresentationValue(feature),
  ]

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim()
    }
  }

  return ''
}
